import { render, staticRenderFns } from "./ia-suggestions-pending-badge.vue?vue&type=template&id=370300b0&scoped=true&"
import script from "./ia-suggestions-pending-badge.vue?vue&type=script&lang=js&"
export * from "./ia-suggestions-pending-badge.vue?vue&type=script&lang=js&"
import style0 from "./ia-suggestions-pending-badge.vue?vue&type=style&index=0&id=370300b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370300b0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370300b0')) {
      api.createRecord('370300b0', component.options)
    } else {
      api.reload('370300b0', component.options)
    }
    module.hot.accept("./ia-suggestions-pending-badge.vue?vue&type=template&id=370300b0&scoped=true&", function () {
      api.rerender('370300b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/ia-suggestions-pending-badge/ia-suggestions-pending-badge.vue"
export default component.exports